"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LOAD_OR_SEARCH_EMBED = exports.EMBED_LINK_INFO = exports.UPLOAD_CALLBACK = exports.UPLOAD_PRESIGNED_URL = exports.GET_URL_META_BATCH = exports.GET_URL_META = exports.GET_LABS_FEATURE_LIST = exports.GET_LABS_FEATURE = exports.CREATE_REPORTS = exports.CODE_EXCHANGE = exports.APP_DISABLE = exports.APP_ENABLE = exports.GET_MARKETPLACE_APPS = exports.OFFICE_PREVIEW = exports.UPLOAD_ATTACH = exports.NEST_BASE_URL = exports.BASE_URL = void 0;
__exportStar(require("../../user/api/url.auth"), exports);
__exportStar(require("../../user/api/url.user"), exports);
__exportStar(require("../../space/api/url.space"), exports);
__exportStar(require("../../space/api/url.node"), exports);
__exportStar(require("../../enterprise"), exports);
__exportStar(require("../../org/api/url.org"), exports);
__exportStar(require("../../space/api/url.template"), exports);
__exportStar(require("../../widget/api/url.widget"), exports);
__exportStar(require("../../database/api/url.data"), exports);
__exportStar(require("../../space/api/url.notification"), exports);
__exportStar(require("../../space/api/url.appstore"), exports);
/**
 * Main API URL Address
 */
exports.BASE_URL = '/api/v1';
/**
 * Nest Base Url
 */
exports.NEST_BASE_URL = '/nest/v1';
/**
 * Upload attachments
 */
exports.UPLOAD_ATTACH = '/base/attach/upload';
/**
 * The url to get attachment preview
 */
exports.OFFICE_PREVIEW = '/base/attach/officePreview/:spaceId';
// Space Station - Get a list of third-party apps SINGLE_APP_INSTANCE
exports.GET_MARKETPLACE_APPS = '/marketplace/integration/space/:spaceId/apps';
// space station - start the application
exports.APP_ENABLE = '/marketplace/integration/space/:spaceId/app/:appId/open';
// space station - close the app
exports.APP_DISABLE = 'marketplace/integration/space/:spaceId/app/:appId/stop';
// =============== V code =======================
exports.CODE_EXCHANGE = '/vcode/exchange/';
// =============== player related =======================
// ================ Risk control related =======================
// Content risk control
exports.CREATE_REPORTS = '/censor/createReports';
// ================ Risk control related =======================
// Get the experimental features that are enabled
exports.GET_LABS_FEATURE = 'user/labs/features';
// Get a list of experimental features
exports.GET_LABS_FEATURE_LIST = 'labs/features';
// Get URL related information, used for URL column identification
exports.GET_URL_META = '/internal/field/url/awareContent';
exports.GET_URL_META_BATCH = '/internal/field/url/awareContents';
// Attachment direct upload
exports.UPLOAD_PRESIGNED_URL = '/asset/upload/preSignedUrl';
exports.UPLOAD_CALLBACK = 'asset/upload/callback';
// ============ Character related end =====================//
// Get EmbedLink Info
exports.EMBED_LINK_INFO = 'embedlinks';
exports.LOAD_OR_SEARCH_EMBED = 'embedlinks/:embedId/org/loadOrSearch';
//# sourceMappingURL=url.js.map